export default {
  //for admin role
  items2: [
    {
      role: "maker",
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "info",
        text: "",
      },
    },
    {
      title: true,
      name: "Components",
      wrapper: {
        element: "span",
        attributes: {},
      },
      role: "maker",
    },
    {
      name: "Reports",
      url: "/reports",
      icon: "fa fa-list",
      role: "admin",
      children: [
        {
          name: "Payment Due",
          url: "/paymt/due",
          icon: "fa fa-credit-card",
        },
        {
          name: "Party Due",
          url: "/masters/partyDue",
          icon: "fa fa-bars",
        },
        {
          name: "Beat Payment Due",
          url: "/paymt/beatDue",
          icon: "fa fa-road",
        },
        {
          name: "Cheque Details",
          url: "/reports/chequeDetails",
          icon: "fa fa-file-check",
        },
        {
          name: "Loading Sheet",
          url: "/reports/loadingSheet",
          icon: "fa fa-truck",
        },
      ],
    },

    {
      name: "Register",
      url: "/upload",
      icon: "fa fa-list-ul",
      role: "admin",
      children: [

        {
          name: "Sales Register",
          url: "/sales/register",
          icon: "fa fa-registered",
        },
        {
          name: "Bill-Wise Upload",
          url: "/sales/upload",
          icon: "fa fa-upload",
        },
        {
          name: "Purchase Upload",
          url: "/purchase/upload",
          icon: "fa fa-shopping-cart",
        },
        {
          name: "Secondary Sales Register",
          url: "/sales/secondarySaleRegister",
          icon: "fa fa-registered",
        },
        {
          name: "Vehicles Number Upload",
          url: "/vehicles/upload",
          icon: "fa fa-truck",
        },
        {
          name: "Dues Verification By Orders",
          url: "/dues/verification",
          icon: "fa fa-check",
        },
        {
          name: "Cash Details Center",
          url: "/cash/details",
          icon: "fa fa-money",
        },

      ]
    },
    {
      role: "admin",
      name: "Sales Summary",
      url: "/sales/summery",
      icon: "fa fa-list-alt",
    },
    {
      role: "admin",
      name: "Payment History",
      url: "/sales/pmthis",
      icon: "fa fa-history",
    },

    {
      role: "admin",
      name: "Receive Payment",
      url: "/paymt/receive",
      icon: "fa fa-inr",
    },
    {
      role: "admin",
      name: "Bank Accounts",
      url: "/sales/acclist",
      icon: "fa fa-bank",
    },
    {
      role: "admin",
      name: "GST Details",
      url: "/reports/gst_details",
      icon: "fa fa-check-square",
    },
    {
      role: "admin",
      name: "Expenses",
      url: "/settings/expense",
      icon: "fa fa-camera-retro",
    },
    {
      role: "admin",
      name: "Day Book",
      url: "/reports/dayBook",
      icon: "fa fa-book",
    },
    {
      name: "Invoice",
      url: "/invoice",
      icon: "fa fa-list-ul",
      role: "admin",
      children: [

        {
          name: "Create Invoice",
          url: "/masters/saleInsert",
          icon: "fa fa-file",
        },
        {
          name: "Upload Invoice",
          url: "/sales/invoieUpload",
          icon: "fa fa-upload",
        }
      ]
    },
    {
      role: "admin",
      name: "Party Details",
      url: "/masters/partyDetails",
      icon: "fa fa-info-circle",
    },
    {
      role: "admin",
      name: "Stock Details",
      url: "/masters/stockDetails",
      icon: "fa fa-boxes",
    },

    {
      name: "Masters",
      url: "/upload",
      icon: "fa fa-list-ul",
      role: "admin",
      children: [

        {
          name: "Party Upload",
          url: "/masters/partyUpload",
          icon: "fa fa-user-tie",
        },
        {
          name: "Rate Upload",
          url: "/masters/rateUpload",
          icon: "fa fa-tags",
        },
        {
          name: "Assets and Liabilities ",
          url: "/masters/assetsLiabilities",
          icon: "fa fa-balance-scale",
        },
        {
          role: "admin",
          name: "Document Center",
          url: "/masters/documents",
          icon: "fa fa-folder-open"
        },
        {
          role: "admin",
          name: "Investors",
          url: "/masters/investors",
          icon: "fa fa-hand-holding-usd"
        },
        {
          role: "admin",
          name: "Recurring Setup",
          url: "/masters/recurringSetup",
          icon: "fa fa-redo"
        },
        {
          role: "admin",
          name: "Email Sync Center",
          url: "/masters/emailSyncCenter",
          icon: "fa fa-envelope"
        }
      ]
    },

  ],
  items3: [
    {
      role: "maker",
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-speedometer",
      badge: {
        variant: "info",
        text: "",
      },
    },
    {
      title: true,
      name: "Components",
      wrapper: {
        element: "span",
        attributes: {},
      },
      role: "maker",
    },
    {
      name: "Reports",
      url: "/reports",
      icon: "fa fa-list",
      role: "admin",
      children: [
        {
          name: "Payment Due",
          url: "/paymt/due",
          icon: "fa fa-credit-card",
        },
        {
          name: "Party Due",
          url: "/masters/partyDue",
          icon: "fa fa-bars",
        },
        {
          name: "Beat Payment Due",
          url: "/paymt/beatDue",
          icon: "fa fa-road",
        },
        {
          name: "Cheque Details",
          url: "/reports/chequeDetails",
          icon: "fa fa-file-check",
        },
        {
          name: "Secondary Sales Register",
          url: "/sales/secondarySaleRegister",
          icon: "fa fa-registered",
        },
        {
          name: "Vehicles Number Upload",
          url: "/vehicles/upload",
          icon: "fa fa-truck",
        },
        {
          name: "Dues Verification By Orders",
          url: "/dues/verification",
          icon: "fa fa-check",
        }
      ],
    },

    {
      name: "Register",
      url: "/upload",
      icon: "fa fa-list-ul",
      role: "admin",
      children: [

        {
          name: "Sales Register",
          url: "/sales/register",
          icon: "fa fa-registered",
        },
        {
          name: "Bill-Wise Upload",
          url: "/sales/upload",
          icon: "fa fa-upload",
        },
        {
          name: "Purchase Upload",
          url: "/purchase/upload",
          icon: "fa fa-shopping-cart",
        }
      ]
    },
    {
      role: "admin",
      name: "Sales Summary",
      url: "/sales/summery",
      icon: "fa fa-list-alt",
    },
    {
      role: "admin",
      name: "Payment History",
      url: "/sales/pmthis",
      icon: "fa fa-history",
    },
    {
      role: "admin",
      name: "Receive Payment",
      url: "/paymt/receive",
      icon: "fa fa-inr",
    },
    {
      role: "admin",
      name: "Expenses",
      url: "/settings/expense",
      icon: "fa fa-camera-retro",
    },
    {
      role: "admin",
      name: "Day Book",
      url: "/reports/dayBook",
      icon: "fa fa-book",
    },
    {
      name: "Invoice",
      url: "/invoice",
      icon: "fa fa-list-ul",
      role: "admin",
      children: [

        {
          name: "Create Invoice",
          url: "/masters/saleInsert",
          icon: "fa fa-file",
        },
        {
          name: "Upload Invoice",
          url: "/sales/invoieUpload",
          icon: "fa fa-upload",
        }
      ]
    },
    {
      role: "admin",
      name: "Party Details",
      url: "/masters/partyDetails",
      icon: "fa fa-info-circle",
    },
    {
      role: "admin",
      name: "Stock Details",
      url: "/masters/stockDetails",
      icon: "fa fa-cubes"
    },
    {
      role: "admin",
      name: "Document Center",
      url: "/masters/documents",
      icon: "fa fa-folder-open"
    },
    {
      role: "admin",
      name: "Investors",
      url: "/masters/investors",
      icon: "fa fa-hand-holding-usd"
    },
    {
      role: "admin",
      name: "Recurring Setup",
      url: "/masters/recurringSetup",
      icon: "fa fa-redo"
    },
    {
      role: "admin",
      name: "Email Sync Center",
      url: "/masters/emailSyncCenter",
      icon: "fa fa-envelope"
    }
  ],
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/_nav.js